import { dayjs } from "../../helpers/dayjs"

export const getDeliveryDateRowCel = (sortedMinistrationsPlan, status, ministrationsPlan) => {
  const periodColumns = {}

  sortedMinistrationsPlan.forEach(ministrationPlan => {
    const startDate = dayjs(ministrationPlan?.revisionStartDate)
      .set("date", ministrationsPlan?.monthlyReviewDueDate || 1)
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0)
    const endDate = dayjs(ministrationPlan?.revisionEndDate)
      .set("date", ministrationsPlan?.monthlyReviewDueDate || 1)
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0)

    let currentDate = startDate
    let ministrationMonths = []

    while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
      const formattedCurrentDate = dayjs(currentDate)
        .add(1, "month")
        .format("DD/MMMM/YYYY")
        .toLowerCase()
      ministrationMonths = [...ministrationMonths, formattedCurrentDate]
      currentDate = currentDate.add(1, "month")
    }

    const lf = new Intl.ListFormat("es")
    periodColumns[`period${ministrationPlan.orderIndex}`] = lf.format(ministrationMonths)
  })

  return { status, ...periodColumns }
}
